import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';
import CustomLoading from 'modules/_shared/components/CustomLoading';

import { EQUITY_MARKET_CONTRACT_TEMPLATE_VARIABLES } from '../constants/equityMarketContractTemplateVariables';
import { useEditEquityMarketSharePurchaseContractTemplateModal } from '../context/EditEquityMarketSharePurchaseContractTemplateModalContext';
import { applyEquityMarketContractPreviewPlaceholders } from '../utils/applyEquityMarketContractPreviewPlaceholders';

const EditEquityMarketSharePurchaseContractTemplateModalBody: FC = () => {
  const { t } = useTranslate();
  const { data, actions } =
    useEditEquityMarketSharePurchaseContractTemplateModal();

  if (data.isLoading) {
    return (
      <Modal.Body className="position-relative" style={{ minHeight: 200 }}>
        <CustomLoading />
      </Modal.Body>
    );
  }

  if (data.loadError) {
    return (
      <Modal.Body>
        <p className="text-danger mb-0">{t('EquityMarketContractTemplateLoadError')}</p>
      </Modal.Body>
    );
  }

  return (
    <Modal.Body>
      <div className="nk-modal">
        <p className="text-soft mb-3 fs-13px">
          {t('EditEquityMarketSharePurchaseContractTemplateIntro')}
        </p>

        <div className="mb-3">
          <p className="overline-title text-soft mb-2">
            {t('EquityMarketContractAvailableVariables')}{' '}
            <span className="text-soft fw-normal fs-12px">
              {t('EquityMarketContractVariablesHint')}
            </span>
          </p>
          <div className="d-flex flex-wrap align-items-center" style={{ gap: 8 }}>
            {EQUITY_MARKET_CONTRACT_TEMPLATE_VARIABLES.map(({ token, labelKey }) => (
              <button
                key={token}
                type="button"
                className="btn btn-xs btn-dim btn-outline-secondary"
                onClick={() => actions.insertVariable(token)}
              >
                {t(labelKey)}
              </button>
            ))}
          </div>
        </div>

        <div className="form-group mb-2">
          <label className="form-label" htmlFor="equity-market-contract-editor">
            {t('EquityMarketContractTemplateBodyLabel')}
          </label>
          <textarea
            id="equity-market-contract-editor"
            ref={actions.registerTextareaRef}
            className="form-control"
            rows={18}
            value={data.contractText}
            onChange={(e) => actions.setContractText(e.target.value)}
            placeholder={t('EquityMarketContractTemplatePlaceholder')}
          />
          <div className="form-note mt-1">
            {t('EquityMarketContractVariablesNote')}
          </div>
        </div>

        {data.showPreview && (
          <div className="card card-bordered mt-3">
            <div className="card-inner">
              <h6 className="card-title mb-2">
                {t('EquityMarketContractPreviewTitle')}
              </h6>
              <p className="text-soft fs-12px mb-2">
                {t('EquityMarketContractPreviewHint')}
              </p>
              <pre
                className="p-3 bg-lighter rounded mb-0 fs-13px"
                style={{ whiteSpace: 'pre-wrap', maxHeight: 320, overflow: 'auto' }}
              >
                {applyEquityMarketContractPreviewPlaceholders(data.contractText)}
              </pre>
            </div>
          </div>
        )}
      </div>
    </Modal.Body>
  );
};

export default EditEquityMarketSharePurchaseContractTemplateModalBody;
